export const FuelFoundationIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7.99826 1.99951C7.99826 1.99951 3.99902 5.99875 3.99902 9.49809C3.99902 10.5588 4.42037 11.576 5.17037 12.326C5.92038 13.076 6.9376 13.4973 7.99826 13.4973C9.05893 13.4973 10.0762 13.076 10.8262 12.326C11.5762 11.576 11.9975 10.5588 11.9975 9.49809C11.9975 5.99875 7.99826 1.99951 7.99826 1.99951Z"
      stroke="currentColor"
      strokeWidth="1.29975"
      strokeLinejoin="round"
    />
    <path
      d="M7.99902 12.9985C6.89902 12.9985 5.99902 12.2985 5.99902 11.1985C5.99902 9.69853 7.99902 7.99854 7.99902 7.99854C7.99902 7.99854 9.99902 9.69853 9.99902 11.1985C9.99902 12.2985 9.09902 12.9985 7.99902 12.9985Z"
      stroke="currentColor"
      strokeWidth="1.19977"
      strokeLinejoin="round"
    />
  </svg>
);
